export const RRS_REFIN = {
  type: 'product',
  price: '350000',
  name: 'Refinansiering',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  url: 'https://scoopr.no/refinansiering',
};
